import React from "react";
import { CommonIconProps } from "./types";
import { IconBase } from "./IconBase"; // Import IconBase

export const IconPdf: React.FC<CommonIconProps> = (props) => {
  return (
    <IconBase
      iconStyle="solid"
      {...props}
      pathData={
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.25 14C6.25 13.5858 6.58579 13.25 7 13.25H8.5C9.74264 13.25 10.75 14.2574 10.75 15.5C10.75 16.7426 9.74264 17.75 8.5 17.75H7.75V19C7.75 19.4142 7.41421 19.75 7 19.75C6.58579 19.75 6.25 19.4142 6.25 19V14ZM7.75 16.25H8.5C8.91421 16.25 9.25 15.9142 9.25 15.5C9.25 15.0858 8.91421 14.75 8.5 14.75H7.75V16.25ZM11.75 14C11.75 13.5858 12.0858 13.25 12.5 13.25H13.7857C15.1266 13.25 16.25 14.3122 16.25 15.6667V17.3333C16.25 18.6878 15.1266 19.75 13.7857 19.75H12.5C12.0858 19.75 11.75 19.4142 11.75 19V14ZM13.25 14.75V18.25H13.7857C14.3383 18.25 14.75 17.8198 14.75 17.3333V15.6667C14.75 15.1802 14.3383 14.75 13.7857 14.75H13.25ZM17.25 14C17.25 13.5858 17.5858 13.25 18 13.25H21C21.4142 13.25 21.75 13.5858 21.75 14C21.75 14.4142 21.4142 14.75 21 14.75H18.75V15.75H20.5C20.9142 15.75 21.25 16.0858 21.25 16.5C21.25 16.9142 20.9142 17.25 20.5 17.25H18.75V19C18.75 19.4142 18.4142 19.75 18 19.75C17.5858 19.75 17.25 19.4142 17.25 19V14Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.27427 19.823C2.27678 21.4403 3.58211 22.75 5.19144 22.75H16.8328C18.0256 22.75 19.0512 22.0306 19.5033 21H7C5.89543 21 5 20.1046 5 19V14C5 12.8954 5.89543 12 7 12H19.75V9.05498C19.75 8.79546 19.6473 8.5466 19.4645 8.36329L12.6564 1.53551C12.4741 1.35268 12.2271 1.25 11.9695 1.25H5.16717C3.55429 1.25 2.24749 2.56532 2.25 4.18619L2.27427 19.823ZM11.5673 3.20594L17.8043 9.46094H13.0673C12.2389 9.46094 11.5673 8.78936 11.5673 7.96094V3.20594Z"
            fill="currentColor"
          />
        </>
      }
    />
  );
};
